import { Button, ButtonVariants, Icons } from "@app/shared";
import { FC, MouseEventHandler, PropsWithChildren, ReactNode, useState } from "react";
import { ErrorAlert } from "./ErrorAlert";
import { Modal } from "./Modal";


export type DialogProps = {
    show: boolean,
    title: string,
    disableOkButton?: boolean,
    onOkClick?: MouseEventHandler,
    onCancelClick?: MouseEventHandler,
    closeOnOutsideClick?: boolean,
    showCancelButton?: boolean,
    showOkButton?: boolean,
    okButtonText?: string,
    children: ReactNode,
    className?: string,
    footerLeft?: ReactNode
};

export const Dialog: FC<PropsWithChildren<DialogProps>> = (props) => {
    var [disableButtons, setDisableButtons] = useState(false);
    const [onClickError, setOnClickError] = useState<string>();
    const onClickOutsideHandler = (props.closeOnOutsideClick ?? true) ? props.onCancelClick : undefined;
    const handleOkClick: MouseEventHandler = async (event) => {
        if (props.disableOkButton) { return; }
        setOnClickError(undefined);
        setDisableButtons(true);
        if (props.onOkClick) {
            try {
                await props.onOkClick(event);
            } catch (e) {
                setOnClickError(e + "");
                console.log(e);
            }
        }
        //If the onOkClick hides the dialog, we may not have state to update anymore
        try {
            setDisableButtons(false);
        } catch { }
    }
    const handleClickOutside: MouseEventHandler = async (event) => {
        if (disableButtons)
            return;
        setOnClickError(undefined);
        setDisableButtons(true);
        if (onClickOutsideHandler)
            await onClickOutsideHandler(event);
        try {
            setDisableButtons(false);
        } catch { }
    }
    const handleCancelClick: MouseEventHandler = async (event) => {
        setOnClickError(undefined);
        setDisableButtons(true);
        if (props.onCancelClick) {
            await props.onCancelClick(event);
        }
        try {
            setDisableButtons(false);
        } catch { }
    }
    return (
        <Modal show={props.show} onClickOutside={handleClickOutside} className={props.className}>
            <div className={"flex flex-col z-50"}>
                <div className="flex py-5 px-5 border-b border-separators-page bg-background-dialog-title rounded-t text-bright-text ">
                    <div className="flex flex-initial">
                        <h1>{props.title}</h1>
                    </div>
                    <div className="flex flex-grow justify-end">
                        {(props.onCancelClick && !disableButtons) &&
                            <div onClick={handleCancelClick} className="cursor-pointer text-muted-body-text hover:text-link-page">
                                <Icons.Close size={32} />
                            </div>
                        }
                    </div>
                </div>
                <div className={`px-5 py-5 flex-grow`} >
                    <ErrorAlert errors={onClickError} />
                    {props.children}
                </div>
                {(props.showOkButton !== false) && <div className={`flex items-center gap-3 py-3 px-5 border-t border-separators-page bg-background-dialog-footer ${props.footerLeft ? "justify-between" : "justify-end"}`}>
                    {props.footerLeft && <div className="flex items-center">{props.footerLeft}</div>}
                    <div className="flex items-center">
                        <Button onClick={handleOkClick} disabled={props.disableOkButton || disableButtons}>{props.okButtonText ?? "OK"}</Button>
                        {
                            (props.onCancelClick && (props.showCancelButton ?? true)) &&
                            <Button onClick={handleCancelClick} disabled={disableButtons} variant={ButtonVariants.Secondary}>Cancel</Button>
                        }
                    </div>
                </div>}
            </div>
        </Modal>
    );
}
